<template>
    <div class="position">
        <div class="widget" v-for="widget in widgets" :key="widget.id" :title="widget.title">
            <div v-if="!widget.hideTitle">
                <h1 class="module-title">{{widget.title}}</h1>
            </div>
            <template v-if="widget.type == 'menu'">
                <WidgetMenu :menus="widget.menuItems" :hideMenuImage="widget.hideMenuImage"/>
            </template>
            <div v-else-if="widget.type == 'html'" v-html="widget.content"></div>
            <template v-else>
                Не задан тип виджета
            </template>
        </div>
    </div>
</template>

<script>
    import WidgetMenu from "@/components/widget/WidgetMenu";
    import CMS from "@/model/cms";

    export default {
        components: {
            WidgetMenu
        },
        props: {
            position: String,
            useTab: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            widgets: []
        }),
        mounted() {
            CMS.loadWidgetByPosition(this.position)
                .then(response => {
                    this.widgets = response.data;
                })
                .catch(error => {
                    //@todo ошибки
                })
            ;
        }
    };
</script>
